import React from 'react';
import RoomPreferencesIcon from '@mui/icons-material/RoomPreferences';
import { MenuItem } from '@mui/material';

import { showNotOnMobileDialog, showPresetsDialog } from '../../store/actions/popupActions';
import { settingsShouldBeViewOnly } from '../../store/selectors/viewOnlyModeSelectors';
import { useAppDispatch, useAppSelector, useIsClientInMobileMode } from '../hooks';

export function OpenPresetsDialogMenuItem(props: { onClick(): void }) {
  const dispatch = useAppDispatch();
  const mobile = useIsClientInMobileMode();
  const readOnly = useAppSelector(settingsShouldBeViewOnly);

  return (
    <MenuItem
      disabled={readOnly}
      onClick={() => {
        if (mobile) {
          dispatch(showNotOnMobileDialog('Presets are not yet available on mobile.'));
        } else {
          dispatch(showPresetsDialog());
        }

        props.onClick();
      }}
    >
      <RoomPreferencesIcon sx={{ mr: 1 }} />
      Manage Presets
    </MenuItem>
  );
}
